"use client"

import * as React from "react"
import { LucideIcon } from "lucide-react"
import { useComingSoon } from "./coming-soon-modal"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavSecondary({
  items,
  currentPath,
  ...props
}: {
  items: {
    title: string
    url: string
    icon: LucideIcon
  }[];
  currentPath?: string;
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const { showComingSoon } = useComingSoon();

  const isActive = (url: string) => {
    if (!currentPath) return false;
    return currentPath === url;
  };

  const handleItemClick = (item: { title: string; url: string; icon: LucideIcon }) => {
    const descriptions: { [key: string]: string } = {
      'Settings': 'Customize your SpyGlass experience with personalized preferences, notifications, and account settings.',
      'Help & Support': 'Get comprehensive help documentation, tutorials, and direct support from our team.',
      'Search': 'Advanced search capabilities across all your analyses, reports, and ingredient database.'
    };

    showComingSoon(item.title, descriptions[item.title] || 'This feature is under development.');
  };

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                onClick={() => handleItemClick(item)}
                className={`cursor-pointer hover:bg-accent hover:text-accent-foreground ${
                  isActive(item.url) ? 'bg-accent text-accent-foreground border-l-2 border-primary' : ''
                }`}
              >
                <item.icon />
                <span>{item.title}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
